import { game } from '../main';
import { changeTexture } from '../utils/changeTexture';
import { playSound } from '../handlers/playSound';
import { createOneLineText } from '../Components/OneLineText';

export class Button extends Phaser.Button {
  public sfx: string = 'button_click';
  public active: boolean = true;
  public onClick: Phaser.Signal = new Phaser.Signal();
  public immediate: boolean = false;

  constructor(
    x: number,
    y: number,
    sprite: string,
    callback?: () => void,
  ) {
    super(game, x, y, undefined, () => this.click());

    changeTexture(this, sprite);
    this.anchor.setTo(0.5);

    if (callback) this.onClick.add(callback);
  }

  public click = () => {
    if (!this.active) return;

    this.active = false;
    this.onClick.dispatch();

    if (this.sfx) playSound(this.sfx);

    if (this.immediate) {
      this.active = true;
    } else {
      game.add.tween(this.scale).to({x: 1.1, y: 1.1}, 100, Phaser.Easing.Quadratic.Out, true)
        .onComplete.addOnce(() => {
          game.add.tween(this.scale).to({
            x: 1,
            y: 1,
          }, 100, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(() => {
              this.active = true;
            })
        });
    }
  }

  public addTextLabel(font: string, text: string, size?: number) {
    const label = createOneLineText(
      0, 0, font, text,
      size || Math.floor(this.height * 0.7),
      this.width * 0.9,
      0.5,
      0.5,
    );
    label.hitArea = new Phaser.Rectangle(0, 0, 0, 0);
    this.addChild(label);
  }
}